import _ from "lodash";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import Hrv from "./Hrv";

const HrvController = (app) => {
  app.get("/hrv", async ({ res, req, locals, load }) => {
    const { query } = req;

    const isAllowToViewAllOrganizationsAthletes =
      locals.organizationRoleName &&
      (locals.organizationRoleName === "Owner" ||
        locals.organizationRoleName === "Admin");

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const { checkin, showBack } = query;

    let comesFromCheckin = false;

    if (Boolean(checkin) && req?.original?.headers?.referer) {
      comesFromCheckin =
        req.original.headers.referer.includes("check-in-summary");
    }
    if (showBack) comesFromCheckin = true;
    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <Hrv comesFromCheckin={comesFromCheckin} />;
  });
};

export default HrvController;
